'use strict';

import {EwSiteApp} from "./ewsiteapp.js";

import intlTelInput from 'intl-tel-input';
import MediumEditor from 'medium-editor';
import 'medium-editor/dist/css/medium-editor.css';
import 'medium-editor/dist/css/themes/default.css';

EwSiteApp.directive('ewFocused', function(){
	return function(scope, elem, attr){
		elem[0].focus();
	};
});

EwSiteApp.directive('ewLongText', function(){
	return {
		restrict: 'E',
		scope: {
			text: '=',
			length: '=?',
			truncate: '=?',
		},
		link: function(scope){
			scope.long = false;
			scope.position = 'top';
			if(isNaN(scope.length)){
				scope.length = 10000;
			}
			else{
				scope.length = parseInt(scope.length);
			}
			if(scope.text){
				scope.long = (scope.text.length > scope.length);
			}
			if (typeof scope.truncate != 'boolean') {
				scope.truncate = false;
			}
		},
		template: '<md-tooltip ng-if="long" md-direction="{{position}}" class="ew-long-text">{{text}}</md-tooltip><div ng-if="long" class="ew-long-text-holder">{{text|limitTo:length}}...</div><div ng-if="!long" ng-class="{truncated: truncated}">{{text}}</div>'
	};
});

EwSiteApp.directive('ewSelectSearchTree', function(){
	return {
		restrict: 'A',
		scope: {
			ngModel: '=',
			ewSelectOptions: '&',
			ewPlaceholder: '@?',
			ewResultStringLength: '<?',
			ewLabel: '@?',
			ewEmptyOption: '@?',
			ewKey: '@?',
			ewMax: '@?'
		},
		link: function(scope, element, attrs){
			element.find('input').on('keydown', function (ev) {
				ev.stopPropagation();
			});
			attrs.mdOnClose = function(){
				scope.onClose();
			};
			attrs.mdOnOpen = function(){
				if(typeof(scope.ewMax) === 'undefined'){
					scope.style = {'max-width': element[0].parentNode.offsetWidth+'px'};
				}
			};
			if(typeof(attrs.mdSelectedText) === 'undefined'){
				attrs.mdSelectedText = function(){
					return scope.getLevelPathValue(scope.ngModel, scope.ewLabel);
				};
			}
			scope.style = {};
			if(typeof(scope.ewMax) !== 'undefined'){
				scope.style = {'max-width': scope.ewMax};
			}
			if(isNaN(scope.ewResultStringLength)){
				scope.ewResultStringLength = 100;
			}
			else{
				scope.ewResultStringLength = parseInt(scope.ewResultStringLength);
			}
		},
		controller: ["$scope", function($scope){
			$scope.searchTerm = '';
			if($scope.ewPlaceholder === ''){
				$scope.ewPlaceholder = 'Search...';
			}
			
			$scope.onClose = function(){
				$scope.searchTerm = '';
			};
			$scope.isSearch = function(){
				return ($scope.searchTerm !== '');
			};
			$scope.getLevelArray = function(level){
				if(isNaN(level)){
					return [];
				}
				let lev = parseInt(level) - 1;
				if(lev < 1){
					return [];
				}
				return [].constructor(lev);
			};
			$scope.getLevelPathValue = function(element, defaultValue){
				if(element && typeof(element.title) !== 'undefined'){
					if(typeof(element.pathList) !== 'undefined' && element.pathList.length > 1){
						let val = element.pathList.join(' / ');
						if(val.length > $scope.ewResultStringLength){
							return '... / '+ element.title;
						}
						return val;
					}
					return element.title;
				}
				if(defaultValue){
					return defaultValue;
				}
				return '';
			};
			$scope.isEmptyOption = function(){
				return (typeof($scope.ewEmptyOption) !== 'undefined');
			};
			$scope.getOptions = function(){
				return $scope.ewSelectOptions();
			};
			$scope.optionValue = function(obj){
				if(typeof($scope.ewKey) === 'undefined'){
					return obj;
				}
				return obj[$scope.ewKey];
			};
		}],
		template: '<md-select-header class="search-select-header">\
					<input ng-model="searchTerm" aria-label="{{ewPlaceholder}}" type="search" placeholder="{{ewPlaceholder}}" class="select-header-searchbox md-text"/>\
				</md-select-header>\
				<md-optgroup label="scategories" class="search-select-optgroup" ng-style="style">\
					<md-option ng-if="isEmptyOption()" value=""><em>{{ewEmptyOption}}</em></md-option>\
					<md-option ng-repeat="cat in getOptions()|filter:{title:searchTerm}" ng-value="optionValue(cat)" >\
						<span ng-if="!isSearch()" class="cat-level-sep" ng-repeat="x in getLevelArray(cat.level) track by $index">&nbsp;</span>\
						<md-icon ng-if="cat.haschilds">folder_open</md-icon>\
						<md-icon ng-if="!cat.haschilds">article</md-icon> \
						<span ng-if="!isSearch()">{{cat.title}}</span>\
						<span ng-if="isSearch()" md-highlight-text="searchTerm" md-highlight-flags="i">{{getLevelPathValue(cat, cat.title)}}</span>\
					</md-option>\
				</md-optgroup>'
	};
});

EwSiteApp.directive('ewSelectSearchList', function(){
	function postLink(scope, element, attrs, ctrls){
		scope.style = {};
		element.find('input').on('keydown', function (ev) {
			ev.stopPropagation();
		});
		attrs.mdOnClose = function(){
			scope.onClose();
		};
		attrs.mdOnOpen = function(){
			if(typeof(scope.ewMax) === 'undefined'){
				scope.style = {'max-width': element[0].parentNode.offsetWidth+'px'};
			}
		};
		if(typeof(scope.ewValue) === 'undefined'){
			scope.ewValue = 'title';
		}
		if(typeof(scope.ewMax) !== 'undefined'){
			scope.style = {'max-width': scope.ewMax};
		}
	}
	
	return {
		restrict: 'A',
		scope: {
			ewSelectOptions: '&',
			ewPlaceholder: '@?',
			ewKey: '@?',
			ewValue: '@?',
			ewEmptyOption: '@?',
			ewMax: '@?'
		},
		link: postLink,
		controller: ["$scope", function($scope){
			$scope.searchTerm = '';
			if($scope.ewPlaceholder === ''){
				$scope.ewPlaceholder = 'Search...';
			}
			$scope.onClose = function(){
				$scope.searchTerm = '';
			};
			$scope.isSearch = function(){
				return ($scope.searchTerm !== '');
			};
			$scope.isEmptyOption = function(){
				return (typeof($scope.ewEmptyOption) !== 'undefined');
			};
			$scope.getOptions = function(){
				return $scope.ewSelectOptions();
			};
			$scope.optionValue = function(obj){
				if(typeof($scope.ewKey) === 'undefined'){
					return obj;
				}
				return obj[$scope.ewKey];
			};
			$scope.getFilter = function(){
				let filter = {};
				filter[$scope.ewValue] = $scope.searchTerm;
				return filter;
			}
		}],
		template: '<md-select-header class="search-select-header">\
					<input ng-model="searchTerm" aria-label="{{ewPlaceholder}}" type="search" placeholder="{{ewPlaceholder}}" class="select-header-searchbox md-text"/>\
				</md-select-header>\
				<md-optgroup label="scategories" class="search-select-optgroup" ng-style="style">\
					<md-option ng-if="isEmptyOption()" value=""><em>{{ewEmptyOption}}</em></md-option>\
					<md-option ng-repeat="row in getOptions()|filter:getFilter()" ng-value="optionValue(row)"><span md-highlight-text="searchTerm" md-highlight-flags="i">{{row[ewValue]}}</span></md-option>\
				</md-optgroup>'
	};
});

EwSiteApp.directive('ewSelectSearchPlaces', function(){
	return {
		restrict: 'A',
		scope: {
			ewSelectOptions: '&',
			ewPlaceholder: '@?',
			ewKey: '@?',
			ewValue: '@?',
			ewOccupied: '@?',
			ewMax: '@?'
		},
		link: function(scope, element, attrs){
			element.find('input').on('keydown', function (ev) {
				ev.stopPropagation();
			});
			attrs.mdOnClose = function(){
				scope.onClose();
			};
			attrs.mdOnOpen = function(){
				if(typeof(scope.ewMax) === 'undefined'){
					scope.style = {'max-width': element[0].parentNode.offsetWidth+'px'};
				}
			};
			if(typeof(scope.ewValue) === 'undefined'){
				scope.ewValue = 'title';
			}
			scope.style = {};
			if(typeof(scope.ewMax) !== 'undefined'){
				scope.style = {'max-width': scope.ewMax};
			}
		},
		controller: ["$scope", function($scope){
			$scope.searchTerm = '';
			if($scope.ewPlaceholder === ''){
				$scope.ewPlaceholder = 'Search...';
			}
			
			$scope.onClose = function(){
				$scope.searchTerm = '';
			};
			$scope.isSearch = function(){
				return ($scope.searchTerm !== '');
			};
			$scope.getOptions = function(){
				return $scope.ewSelectOptions();
			};
			$scope.optionValue = function(obj){
				if(typeof($scope.ewKey) === 'undefined'){
					return obj;
				}
				return obj[$scope.ewKey];
			};
		}],
		template: '<md-select-header class="search-select-header">\
					<input ng-model="searchTerm" aria-label="{{ewPlaceholder}}" type="search" placeholder="{{ewPlaceholder}}" class="select-header-searchbox md-text"/>\
				</md-select-header>\
				<md-optgroup label="scategories" class="search-select-optgroup" ng-style="style">\
					<md-option ng-repeat="row in getOptions()|filter:{title:searchTerm}" ng-value="optionValue(row)"><span md-highlight-text="searchTerm" md-highlight-flags="i">{{row[ewValue]}}</span><span class="ew-explain" ng-if="place.free!=1"> ({{ewOccupied}})</span></md-option>\
				</md-optgroup>'
	};
});

EwSiteApp.directive('projectPageLoader', function(){
	return {
		restrict: 'A',
		controller: ['$scope', 'pageProgress', function($scope, pageProgress){
			$scope.state = function(){
				return pageProgress.getState();
			};
		}]
	};
});

/*
 * Pagal biblioteka intl-tel-input
 * Daugiau info: https://intl-tel-input.com/
 */

EwSiteApp.directive('phoneInput', function(){
	return {
		scope: {
			ngModel: '=',
			phoneModel: '='
		},
		link: function(scope, element, attrs){
			const input = element[0];
			const iti = intlTelInput(input, {
				utilsScript: require('intl-tel-input/build/js/utils.js'),
				nationalMode: true,
				initialCountry: "auto",
				geoIpLookup: function(success, failure) {
					fetch("https://ipapi.co/json")
						.then(res => res.json())
						.then(data => {
							console.log('geoIpLookup:', data.country_code);
							success(data.country_code);
						})
						.catch(err => {
							console.log('geoIpLookup error', err);
							failure();
						});
				},
				separateDialCode: true,
				dropdownContainer: document.body
			});

			input.addEventListener('countrychange', () => {
				updPhoneModel();
			});
			['change','keyup'].forEach(evt =>
				input.addEventListener(evt, e => {
					updPhoneModel();
				})
			);

			scope.$watch('phoneModel', (newV) => {
				if (typeof newV !== 'undefined') {
					iti.setNumber(newV);
				}
			});

			function updPhoneModel(){
				setTimeout(() => {
					const country = iti.getSelectedCountryData();
					const national = (input.value || '').replace(/\D/g, '');
					const full = national ? '+' + country.dialCode + national : '';
					scope.phoneModel = full;
					scope.$apply();
				}, 50);
			}
		}
	};
});


EwSiteApp.directive('md3Input', ['$rootScope', '$compile', function($rootScope, $compile) {
    return {
        restrict: 'A',
        link: function(scope, element) {
            let labelText = element.find('label').text();
            let placeholderText = element.find('input').attr('placeholder') || '';

            // Create the new structure
            let fieldset = angular.element('<fieldset></fieldset>');
            let legend = angular.element('<legend></legend>');
            legend.attr('aria-label', labelText);
            legend.html(labelText);

            let input = element.find('input');
            input.attr('placeholder', placeholderText);

            fieldset.append(legend);
            fieldset.append(input);

            element.find('label').remove();
            element.prepend(fieldset);

            if (!$rootScope.$$phase) {
                scope.$apply(function() {
                    $compile(element.contents())(scope);
                });
            } else {
                //$compile(element.contents())(scope);
            }
        }
    };
}]);

EwSiteApp.directive('md3Select', ['$rootScope', '$compile', function($rootScope, $compile) {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            let labelText = element.find('label').text();
            let placeholderText = element.find('md-select').attr('placeholder') || '';

            let fieldset = angular.element('<fieldset></fieldset>');
            let legend = angular.element('<legend></legend>');
            legend.attr('aria-label', labelText);
            legend.html(labelText);

            let input = element.find('md-select');
            input.attr('placeholder', placeholderText);

            fieldset.append(legend);
            fieldset.append(input);

            element.find('label').remove();
            element.prepend(fieldset);
        }
    };
}]);

EwSiteApp.directive('md3Datepicker', ['$rootScope', '$compile', function($rootScope, $compile) {
    return {
        restrict: 'A',
        link: function(scope, element) {
            let labelText = element.find('label').text();

            let fieldset = angular.element('<fieldset></fieldset>');
            let legend = angular.element('<legend></legend>');
            legend.attr('aria-label', labelText);
            legend.html(labelText);

            let datepicker = element.find('md-datepicker');

            fieldset.append(legend);
            fieldset.append(datepicker);

            element.find('label').remove();
            element.prepend(fieldset);

            if (!$rootScope.$$phase) {
                scope.$apply(function() {
                    $compile(element.contents())(scope);
                });
            } else {
                $compile(element.contents())(scope);
            }
        }
    };
}]);

EwSiteApp.directive('togglePassword', function() {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            element[0].addEventListener('click', function() {
                // Toggle the visibility icon
                if (this.textContent === 'visibility') {
                    this.textContent = 'visibility_off';
                } else {
                    this.textContent = 'visibility';
                }

                // Find the closest parent element with the class 'password-wrapper'
                var parent = this.closest('.password-wrapper');
                // Find the input element within the parent
                var input = parent.querySelector('input[type="password"], input[type="text"]');

                // Toggle the input type
                if (input.getAttribute('type') === 'password') {
                    input.setAttribute('type', 'text');
                } else {
                    input.setAttribute('type', 'password');
                }
            });
        }
    };
});

EwSiteApp.directive('autoSave', ['$timeout', 'jsDataService', function($timeout, jsDataService){
	return {
		restrict: 'A',
		scope: {
			autoSaveFields: '=?',
			name: '@',
			autoSaveCtrl: '=?'
		},
		link: function(scope, element, attrs){
			scope.autosave = jsDataService.get('autosave', {on: false});
			scope.form = scope.$parent[scope.name];
			scope.form.autosave = false;
			if(scope.autosave.on && typeof(scope.autoSaveFields) === 'undefined' && typeof(scope.autoSaveCtrl) === 'undefined'){
				scope.autosave.on = false;
			}
			if(scope.autosave.on){
				scope.autosave.delay = ((typeof(scope.autosave.delay) === 'undefined' || isNaN(scope.autosave.delay)) ? 2000 : parseInt(scope.autosave.delay));
				scope.form.$setPristine();
				scope.form.$setSubmitted();
				
				scope.$watch("form.$pristine", (nval, oval) => {
					if(oval && !nval){
						$timeout(() => {saveData();}, scope.autosave.delay);
					}
				});
				
				window.onbeforeunload = function (event) {
					if(!scope.form.$pristine){
						return true;
					}
				};

				scope.$on('$destroy', function (e) {
					delete window.onbeforeunload;
				});
				scope.form.autosave = true;
				scope.form.saveAndHref = function(link){
					saveData().then(() => {
						scope.$root.goUrl(link);
					});
				};
				
				scope.form.save = function(){
					saveData();
				};
				
				scope.form.isSaved = function(){
					return (scope.form.$submitted && scope.form.$pristine);
				};
				
				scope.$on('autosaveFormChanged', (event, data) => {
					scope.form.$setDirty();
				});
				
				if(typeof(scope.autoSaveCtrl) !== 'undefined' && typeof(scope.autoSaveCtrl.autosaveInit) === 'function'){
					return scope.autoSaveCtrl.autosaveInit(scope.form);
				}
			}
			
			function saveData(){
				if(scope.autoSaveCtrl.autosaveSkip === true){
					console.log('skip autosave');
					return;
				}
				
				if(scope.autosave.url && scope.autosave.url !== ''){
					scope.form.$setPristine();
					return scope.$root.basicHttpConfigProcess({
						url: scope.autosave.url,
						method: 'POST',
						responseType: 'json',
						data: collectFormData()
					}).then((results) => {
						if(results.data.success){
							scope.form.$setSubmitted();
							
							if(typeof scope.autoSaveCtrl.autosaveSuccess === 'function'){
								scope.autoSaveCtrl.autosaveSuccess(results.data);
							}
						}
					});
				}
				return null;
			};
			
			function collectFormData(){
				if(typeof(scope.autoSaveCtrl) !== 'undefined' && typeof(scope.autoSaveCtrl.autosavePostFields) === 'function'){
					return scope.autoSaveCtrl.autosavePostFields();
				}
				let post = [];
				for(let fkey in scope.autoSaveFields){
					post.push(scope.autoSaveFields[fkey].getData());
				}
				return post;
			}
		}
	};
}]);

EwSiteApp.directive('mediumEditor', ['$timeout', function($timeout){
    return {
        restrict: 'A',
        scope: {
            ngModel: '='
        },
        link: function(scope, element, attrs) {
            const editor = new MediumEditor(element, {
                placeholder: { text: '' },
                targetBlank: true,
                toolbar: {
                    buttons: ['bold', 'italic', 'underline', 'anchor', 'unorderedlist', 'orderedlist']
                },
                paste: {
                    cleanPastedHTML: true,
                    cleanAttrs: ['style', 'dir'],
                    cleanTags: ['label', 'meta'],
                    unwrapTags: ['sub', 'sup']
                },
                autoLink: true
            });
			
            editor.subscribe('editableInput', function(event, editable) {
                $timeout(function() {
                    scope.ngModel = editable.innerHTML;
                });
            });

            scope.$watch('ngModel', function(newVal) {
                var currentEditorContent = editor.getContent();
                var incomingVal = newVal || '';

                if (incomingVal === currentEditorContent) {
                    return;
                }

                var isFocused = (document.activeElement === editor.elements[0]);
				
                if (isFocused) {
                    return; 
                }

                editor.setContent(incomingVal);
            });

            scope.$on('$destroy', function() {
                editor.destroy();
            });
        }
    };
}]);

EwSiteApp.directive('fixedDecimal', ["$parse", function($parse) {
	return {
		restrict: 'A',
		require: 'ngModel',
		link: function(scope, element, attrs, ngModel) {
			if (!ngModel) return;
			
			const maxValue = (typeof(attrs.maxValue) !== 'undefined' && /^[0-9\.]+$/.test(attrs.maxValue)) ? parseFloat(attrs.maxValue) : 100;
			
			let changedAttrSetter = null;
			if (attrs.changedAttribute) {
                const changedAttrGetter = $parse(attrs.changedAttribute);
                changedAttrSetter = changedAttrGetter.assign;
            }
			function setAttr(scope, val){
				if(changedAttrSetter){
					changedAttrSetter(scope, val);
				}
			}
			
			function sanitize(value) {
				if (!value) return '';
				let sanitized = value.replace(/[^0-9.]/g, '');
				const dotParts = sanitized.split('.');
				if (dotParts.length > 2) {
					sanitized = dotParts.shift() + '.' + dotParts.join('');
				}
				const parts = sanitized.split('.');
				if (parts[1] && parts[1].length > 10) {
					parts[1] = parts[1].substring(0, 10);
				}
				return parts.join('.');
			}

			element.on('input', function() {
				let value = element.val();
				let sanitized = sanitize(value);
				if (value !== sanitized) {
					ngModel.$setViewValue(sanitized);
					ngModel.$render();
				}
			});

			ngModel.$formatters.push(function(value) {
				if (value !== null && value !== undefined && !isNaN(value)) {
					return value.toString();
				}
				return value;
			});

			ngModel.$parsers.push(function(value) {
				if (!value) {
					return undefined;
				}
				let sanitized = sanitize(value);
				let floatVal = parseFloat(sanitized);
				if (isNaN(floatVal)) {
					return undefined;
				}
				if (floatVal > maxValue) {
					floatVal = maxValue;
					setAttr(scope, true);
				}
				else{
					setAttr(scope, false);
				}
				return parseFloat(floatVal.toFixed(10));
			});

			element.on('blur', function() {
				scope.$applyAsync(function() {
					let value = element.val();
					let sanitized = sanitize(value);
					let floatVal = parseFloat(sanitized);
					if (!isNaN(floatVal)) {
						if (floatVal > maxValue) {
							floatVal = maxValue;
							setAttr(scope, true);
						}
						else{
							setAttr(scope, false);
						}
						let fixed = floatVal.toFixed(10);
						ngModel.$setViewValue(fixed);
						ngModel.$render();
					}
				});
			});
		}
	};
}]);

EwSiteApp.directive('ignoreTimezone', function() {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function(scope, element, attrs, ngModelCtrl) {

        ngModelCtrl.$parsers.push(function(localDate) {
          if (!localDate) {
            return undefined;
          }
          // Create a new Date object in UTC using the year, month, and day
          // from the date picker's local date.
          var utcDate = new Date(Date.UTC(
            localDate.getFullYear(),
            localDate.getMonth(),
            localDate.getDate(),
            localDate.getHours()
          ));
          return utcDate;
        });

        ngModelCtrl.$formatters.push(function(utcDate) {
            if (!utcDate) {
                return undefined;
            }
            // When formatting for the view, create a local date from the UTC date's
            // components to ensure the datepicker displays the correct calendar day.
            var date = new Date(utcDate);
            return new Date(
              date.getUTCFullYear(),
              date.getUTCMonth(),
              date.getUTCDate(),
              date.getUTCHours()
            );
        });
      }
    };
  });